import React from 'react';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../css/card.css';

interface CardBaseProps {
  title: React.ReactNode;
  badge?: number | string;
  icon: IconDefinition | React.ReactElement;
  color: string;
  targetUrl?: string;
  onClick?: () => void;
}

const CardBase: React.FC<CardBaseProps> = ({ title, badge, icon, color, targetUrl, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (targetUrl) {
      window.location.href = targetUrl;
    }
  };

  const handleBadgeClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (targetUrl) {
      window.location.href = targetUrl;
    }
  };

  return (
    <div className="card-wrapper m-2" onClick={handleClick}>
      <div className="card-content" style={{ borderTopColor: color }}>
        <div className="card-icon-container">
          {React.isValidElement(icon) ? (
            icon
          ) : (
            <FontAwesomeIcon 
              icon={icon as IconDefinition} 
              className="card-icon" 
              style={{ color }}
            />
          )}
        </div>
        <div className="card-text-container">
          <div className="card-title-row">
            <span className="card-title">{title}</span>
          </div>
          {badge !== undefined && (
            <div className="card-badge-container">
              <span 
                className="card-badge" 
                style={{ backgroundColor: color }}
                onClick={handleBadgeClick}
              >
                {badge}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardBase;